<template>
   <CRUDList
      ref="crudList"
      noResultOverride="No delinquent records found"
      :canAdd="false"
      :canEdit="false"
      :canSave="false"
      :showSelect="false"
      :displayTopPagination="false"
      :hideDefaultFooter="true"
      :enableFixedHeaders="true"
      :disableKeyboardFunc="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :variableToChangeRowBgColor="[{ varName: 'hasPendingPayment', varCol: '#ffe5006b' }]"
      tableWrapperDynamicClassname='taxroll-table-wrapper-two'
      tableDynamicHeight='85'
    >
    </CRUDList>
</template>
<script>
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { DelqHeader } from '../../TaxInquiryUtils/TableHeaders.utils';
import '../../../../../assets/style.css';

export default {
  name: 'TaxRollDelq',
  components: {
    CRUDList,
  },
  data() {
    return {
      baseCrudKey: 'TaxRollDelq',
      headers: DelqHeader,
    };
  },
  computed: {
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
  },
};
</script>
